export interface BrandConfig {
  key: "lume" | "ns";
  name: string;
  productName: string;
  logo: string;
  favicon: string;
}

const LUME: BrandConfig = {
  key: "lume",
  name: "Lume Divinum",
  productName: "Central de Suporte Lume Divinum",
  logo: "/logo.png",
  favicon: "/favicon.png",
};

const NS: BrandConfig = {
  key: "ns",
  name: "NS Tecnologia",
  productName: "NS Picinatto Helpdesk",
  logo: "/ns-tecnologia-logo.png",
  favicon: "/ns-tecnologia-favicon.png",
};

export function currentBrand(hostname = window.location.hostname): BrandConfig {
  return hostname.toLowerCase().includes("nspicinatto") ? NS : LUME;
}

export function applyBrand(brand: BrandConfig) {
  document.documentElement.dataset.brand = brand.key;
  document.title = brand.productName;
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (favicon) favicon.href = brand.favicon;
}
